import { array, number, oneOfType, string } from "prop-types"
import { useEffect, useState } from "react"

const EmergencyContact = ({
  id,
  options: initialOptions,
  name: initialName,
  phoneNumber: initialPhoneNumber
}) => {
  const [name, setName] = useState(initialName)
  const [phoneNumber, setPhoneNumber] = useState(initialPhoneNumber)
  const [editing, setEditing] = useState(initialOptions.length === 0)
  const [options, setOptions] = useState(initialOptions)

  let selectedIndex = 0

  const handleEmergencyContactSelect = index => {
    if (index === "new") {
      setEditing(true)
      setName("")
      setPhoneNumber("")
    } else {
      const selectedOption = options[parseInt(index)]

      if (selectedOption) {
        setEditing(false)
        setName(selectedOption.name)
        setPhoneNumber(selectedOption.phoneNumber)
      }
    }
  }

  useEffect(() => {
    if (initialOptions.length > 0) {
      if (initialName && initialPhoneNumber) {
        const existingSelectionIndex = options.find(
          ({ name: optionName, phoneNumber: optionPhoneNumber }) =>
            initialName == optionName && initialPhoneNumber == optionPhoneNumber
        )

        if (existingSelectionIndex) {
          selectedIndex = existingSelectionIndex
        } else {
          setOptions(prevOptions => [
            { name: initialName, phoneNumber: initialPhoneNumber },
            ...prevOptions
          ])
        }
      }

      handleEmergencyContactSelect(selectedIndex)
    }
  }, [])

  return (
    <>
      {id && (
        <input type="hidden" name="" id="attendee_emergency_contact_attributes_id" value={id} />
      )}

      {options.length > 0 && (
        // eslint-disable-next-line jsx-a11y/no-onchange
        <select
          onChange={event => handleEmergencyContactSelect(event.target.value)}
          className="select"
          initialValue={selectedIndex}
        >
          {options.map(({ name }, index) => (
            <option key={index} value={index}>
              {name}
            </option>
          ))}
          <option value="new">Create New Emergency Contact</option>
        </select>
      )}

      {editing ? (
        <div>
          <div className="py-1">
            <label
              htmlFor="attendee_emergency_contact_attributes_name"
              className="screen-reader-text"
            >
              Name
            </label>
            <input
              type="text"
              name="attendee[emergency_contact_attributes][name]"
              id="attendee_emergency_contact_attributes_name"
              value={name}
              placeholder="Name"
              onChange={({ target: { value } }) => {
                setName(value)
              }}
            />
          </div>
          <div>
            <label
              htmlFor="attendee_emergency_contact_attributes_phone_number"
              className="screen-reader-text"
            >
              Phone Number
            </label>
            <input
              type="text"
              name="attendee[emergency_contact_attributes][phone_number]"
              id="attendee_emergency_contact_attributes_phone_number"
              value={phoneNumber}
              placeholder="Phone Number"
              onChange={({ target: { value } }) => {
                setPhoneNumber(value)
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <input
            type="hidden"
            name="attendee[emergency_contact_attributes][name]"
            id="attendee_emergency_contact_attributes_name"
            value={name}
          />
          <input
            type="hidden"
            name="attendee[emergency_contact_attributes][phone_number]"
            id="attendee_emergency_contact_attributes_phone_number"
            value={phoneNumber}
          />
        </>
      )}
    </>
  )
}

EmergencyContact.propTypes = {
  id: oneOfType([string, number]),
  name: string,
  phoneNumber: string,
  options: array
}

export default EmergencyContact
